<template>
	<div class="grid">
		<div class="col-12">
			<div class="card">
				<h5>{{ $t('showerRecords.titleByPerson') }}</h5>
				<div class="formgroup-inline">
					<span class="p-float-label mr-3">
						<Dropdown id="eventEnterprise" :options="enterpriseList" v-model="searchParams.enterpriseId"
							optionLabel="name" optionValue="id" filter @change="onEnterpriseChange('search')" :placeholder="$t('showerRecords.filters.enterprise')"
							:show-clear="true"></Dropdown>
					</span>
					<span class="p-float-label mr-3">
						<Dropdown id="eventField" :options="fieldList" v-model="searchParams.enterprisePartitionId"
							optionLabel="site_name" :placeholder="$t('showerRecords.filters.field')" optionValue="id" filter @change="onFieldChange('search')"
							:show-clear="true">
						</Dropdown>
					</span>
					<span class="p-float-label mr-3">
						<Dropdown id="eventRegion" :options="regionList" v-model="searchParams.regionId" :placeholder="$t('showerRecords.filters.region')"
							optionLabel="region_name" optionValue="id" filter :show-clear="true" @change="onRegionChange">
						</Dropdown>
					</span>
					<span class="p-float-label mr-3">
						<Calendar id="eventTimeRange" v-model="searchParams.time" selectionMode="range" :manualInput="false"
							showButtonBar="true" :showIcon="true" hideOnDateTimeSelect="true" :placeholder="$t('showerRecords.filters.timeRange')" />
					</span>
					<Button :label="$t('showerRecords.actions.query')" @click="onSearch"></Button>
					<Button :label="$t('showerRecords.actions.excelDownload')" icon="pi pi-file-excel" class="ml-3" @click="onFileDownload"></Button>
					<!-- 添加显示/隐藏DataTable按钮 -->
					<Button :label="dataTableVisible ? $t('showerRecords.actions.hideUsers') : $t('showerRecords.actions.showUsers')"
						:icon="dataTableVisible ? 'pi pi-eye-slash' : 'pi pi-eye'" class="ml-3"
						@click="toggleDataTable"></Button>
					<ConfirmPopup></ConfirmPopup>
				</div>
			</div>
		</div>
		<div class="col-4" v-show="dataTableVisible">
			<!-- 添加v-show指令控制card显示/隐藏 -->
			<div class="card">
				<DataTable :value="userList" :paginator="true" :rows="pageSize" dataKey="id" :rowHover="true"
					filterDisplay="menu" responsiveLayout="scroll" selectionMode="single" :lazy="true"
					:totalRecords="totalCount" @page="onPage" :rowClass="rowClass">
					<template #header>
						<div class="grid grid-nogutter">
							<SelectButton v-model="currLabelIndex" :options="tabOpts" optionLabel="name" optionValue="code"
								@change="onTabClicked" />
						</div>
					</template>
					<template #empty>
						{{ $t('showerRecords.states.empty') }}
					</template>
					<template #loading>
						{{ $t('showerRecords.states.loading') }}
					</template>

					<Column field="employee_short_id_show" header="ID" style="min-width:5rem">
						<template #body="{ data }">
							{{ data.employee_short_id_show }}
						</template>
					</Column>
					<Column field="name" :header="$t('showerRecords.columns.name')" style="min-width:8rem">
						<template #body="{ data }">
							{{ data.name }}
						</template>
					</Column>
					<Column field="height" :header="$t('showerRecords.columns.height')" style="min-width:5rem">
						<template #body="{ data }">
							{{ data.height }}cm
						</template>
					</Column>

					<Column field="total" :header="$t('showerRecords.columns.count')" style="min-width:5rem">
						<template #body="{ data }">
							<span :class="'customer-badge status-' + (data.total < 4 ? 'unqualified' : 'qualified')">{{
								data.total }}{{ $t('showerRecords.units.times') }}</span>
						</template>
					</Column>

					<Column field="total" :header="$t('showerRecords.columns.record')" style="min-width:8rem">
						<template #body="{ data }">
							<Button icon="pi pi-angle-double-right" class="p-button-rounded p-button-success"
								@click="onUserClick(data)" />
						</template>
					</Column>

				</DataTable>
			</div>
		</div>
		<div :class="dataTableVisible ? 'col-8' : 'col-12'">
			<div class="card">
				<DataTable :value="bathRecordDetailList" :paginator="true" :rows="recordPageSize" :rowsPerPageOptions="[10, 100, 200, 500]" dataKey="id"
					:rowHover="true" filterDisplay="menu" responsiveLayout="scroll" selectionMode="single" lazy
					:totalRecords="recordTotalCount" @page="onRecordPage($event)">
					<template #header>
						<div class="grid grid-nogutter">
							<div class="col-2">
								{{ $t('showerRecords.header.id', { id: currUser.id }) }}
							</div>
							<div class="col-3">
								{{ $t('showerRecords.header.name', { name: currUser.name }) }}
							</div>
							<div class="col-2">
								{{ $t('showerRecords.header.height', { height: currUser.height }) }}
							</div>
							<div class="col">
								{{ $t('showerRecords.header.phone', { phone: currUser.employee_id }) }}
							</div>
						</div>
					</template>
					<template #empty>
						{{ $t('showerRecords.states.empty') }}
					</template>
					<template #loading>
						{{ $t('showerRecords.states.loading') }}
					</template>

					<Column field="times" :header="$t('showerRecords.columns.time')" style="min-width:10rem">
						<template #body="{ data }">
							{{ data.times }}
						</template>
					</Column>
					<Column field="partition_name" :header="$t('showerRecords.columns.location')" style="min-width:15rem">
						<template #body="{ data }">
							{{ data.partition_name }}->{{ data.enterprise_name }}->{{ data.region_name }}
						</template>
					</Column>
					<Column field="device_name" :header="$t('showerRecords.columns.deviceName')" style="min-width:8rem">
						<template #body="{ data }">
							{{ data.device_name }}
						</template>
					</Column>
					<Column field="status" :header="$t('showerRecords.columns.compliance')"  style="min-width:5rem">
						<template #body="{ data }">
							<span :class="'customer-badge status-' + (data.status === 0 ? 'qualified' : 'unqualified')">
								{{ data.status === 0 ? $t('showerRecords.states.qualified') : $t('showerRecords.states.nonCompliant') }}</span>
						</template>
					</Column>
					<Column field="height" :header="$t('showerRecords.columns.height')" style="min-width:8rem">
						<template #body="{ data }">
							{{ data.height }}cm
						</template>
					</Column>
					<Column field="total_time" :header="$t('showerRecords.columns.totalDuration')" style="min-width:8rem">
						<template #body="{ data }">
							{{ seconds2String(data.total_time) }}
						</template>
					</Column>
					<Column field="head_time" :header="$t('showerRecords.columns.headDuration')" style="min-width:8rem">
						<template #body="{ data }">
							{{ seconds2String(data.head_time) }}
						</template>
					</Column>
					<Column field="valid_time" :header="$t('showerRecords.columns.validDuration')" style="min-width:8rem">
						<template #body="{ data }">
							{{ seconds2String(data.valid_time) }}
						</template>
					</Column>
					<Column field="nobody_time" :header="$t('showerRecords.columns.noPerson')" style="min-width:8rem">
						<template #body="{ data }">
							{{ seconds2String(data.nobody_time) }}
						</template>
					</Column>
					<Column field="no_water_time" :header="$t('showerRecords.columns.noWater')" style="min-width:8rem">
						<template #body="{ data }">
							{{ seconds2String(data.no_water_time) }}
						</template>
					</Column>
					<Column field="head_fluid_times" :header="$t('showerRecords.columns.shampoo')" style="min-width:8rem">
						<template #body="{ data }">
							{{ data.head_fluid_times }}{{ $t('showerRecords.units.times') }}
						</template>
					</Column>
					<Column field="body_fluid_times" :header="$t('showerRecords.columns.bodyWash')" style="min-width:8rem">
						<template #body="{ data }">
							{{ data.body_fluid_times }}{{ $t('showerRecords.units.times') }}
						</template>
					</Column>
					<Column field="avg_water_temp" :header="$t('showerRecords.columns.waterTemp')" style="min-width:8rem">
						<template #body="{ data }">
							{{ data.avg_water_temp }}℃
						</template>
					</Column>
					<Column field="sensor_fail" :header="$t('showerRecords.columns.signal')" style="min-width:8rem">
						<template #body="{ data }">
							{{ formatSensorFail(data.sensor_fail) }}
						</template>
					</Column>
					<Column field="name" :header="$t('showerRecords.columns.totalWater')" style="min-width:8rem">
						<template #body="{ data }">
							{{ data.water_usage.toFixed(1) }}{{ $t('showerRecords.units.liters') }}
						</template>
					</Column>
				</DataTable>
			</div>
		</div>
	</div>
	<Dialog v-model:visible="displayDownload" modal :header="$t('showerRecords.download.title')" :style="{ width: '10vw' }">
		<div class="flex flex-wrap justify-content-center ">
			<p>
				{{ $t('showerRecords.download.message') }}
			</p>
			<ProgressSpinner />
		</div>
	</Dialog>
</template>

<script>
import axios from 'axios';
import ProductService from '../service/ProductService';

export default {
	data() {
		return {
			// 添加控制DataTable显示/隐藏的数据属性
			dataTableVisible: true,
			tabOpts: [
				{ name: this.$t('showerRecords.tabs.all'), code: 0 },
				{ name: this.$t('showerRecords.tabs.violation'), code: 1 },
				{ name: this.$t('showerRecords.tabs.noShower'), code: 2 },
			],
			currLabelIndex: 0,
			searchParams: {
				enterpriseId: null,
				enterprisePartitionId: null,
				regionId: null,
				personnelId: null,
				time: '',
			},

			enterpriseList: [],
			fieldList: [],
			regionList: [],
			userList: [],
			bathRecordDetailList: [],

			currUser: {
				id: 0,
				name: "",
				height: 0,
				employee_id: "",
				employee_short_id: "",
				total: 0,
				latest_time: 0,
				employee_short_id_show: "",
			},

			pageIndex: 1,
			pageSize: 10,
			totalCount: 0,

			recordPageIndex: 1,
			recordPageSize: 10,
			recordTotalCount: 0,

			products: null,
		}
	},
	productService: null,
	created() {
		this.productService = new ProductService();
	},
	mounted() {

		this.productService.getProducts().then(data => {
			this.products = data
			console.log(this.products);
		});

		this.enterTreeIdNameMap = new Map();

		this.localUserInfo = JSON.parse(window.localStorage.getItem('userinfo'));
		this.getEnterpriseList();
		this.getUserList();
	},
	watch: {
		'$appState.locale'() {
			this.tabOpts = [
				{ name: this.$t('showerRecords.tabs.all'), code: 0 },
				{ name: this.$t('showerRecords.tabs.violation'), code: 1 },
				{ name: this.$t('showerRecords.tabs.noShower'), code: 2 },
			];
		}
	},
	methods: {
		// 添加切换DataTable显示/隐藏的方法
		toggleDataTable() {
			this.dataTableVisible = !this.dataTableVisible;
		},
		rowClass(data) {
			return data.selected ? 'row-accessories' : null;
		},

		onTabClicked(e, value) {
			this.pageIndex = 1;
			this.getUserList();
		},

		onUserClick(data) {
			for (let i = 0; i < this.userList.length; i++) {
				this.userList[i].selected = false;
			}

			data.selected = true;
			this.currUser = data;
			this.recordPageIndex = 1;
			this.recordTotalCount = 0;
			this.bathRecordDetailList = [];
			this.getBathRecordDetail(false);
		},
		seconds2String(s) {
			let min = (Math.floor(s / 60)).toFixed();
			let sec = (s % 60).toFixed();

			return min + this.$t('showerRecords.units.minutes') + sec + this.$t('showerRecords.units.seconds')
		},
		formatSensorFail(value) {
			if (value === undefined || value === null) {
				return '000';
			}

			if (value === -1) {
				return '---';
			}

			// 转换为二进制并补足三位
			let binaryStr = parseInt(value).toString(2);
			return binaryStr.padStart(3, '0');
		},
		formParams() {
			//获取时间区间
			let start_time = (this.searchParams.time == '' ? new Date(new Date().toLocaleDateString()) : new Date(this.searchParams.time[0]));
			let end_time = (this.searchParams.time == '' ? new Date(new Date().toLocaleDateString()) : new Date(this.searchParams.time[1]));

			return {
				enterprise_id: this.searchParams.enterpriseId ? this.searchParams.enterpriseId : "",
				enter_id: this.searchParams.enterprisePartitionId ? this.searchParams.enterprisePartitionId : "",
				region_id: this.searchParams.regionId ? this.searchParams.regionId : "",
				start_time,
				end_time,
			}
		},

		getUserList() {
			let {
				enterprise_id,
				enter_id,
				region_id,
				start_time,
				end_time
			} = this.formParams();

			this.userList = [];

			//加入中间的选项
			let status = "";
			if (this.currLabelIndex != 2) {
				switch (this.currLabelIndex) {
					case 0:
						break;
					case 1:
						status = 1;
						break;
				}

				this.$http('/api/admin/bathrecord/userList', {
					enterprise_id: enterprise_id,
					enterprise_partition_id: enter_id,
					region_id: region_id,
					time: start_time.getTime(),
					times: end_time.getTime() + 86399999,
					page: this.pageIndex,
					page_size: this.pageSize,
					status: status,
					//less_count: less_count
				}).then(res => {
					if (res.code == 200) {
						this.totalCount = res.data.total;

						var _record_data = res.data.data.map(e => {
							let ee = new Object();
							ee = e;

							if (e.id === null || e.id === -1) {
								ee.id = -1;

								if(ee.local_name){
									ee.name = ee.local_name;
								} else {
									ee.name = this.$t('showerRecords.states.anonymousUser');
								}
								ee.employee_short_id_show = '-1';
							} else {
								ee.employee_short_id_show = e.employee_short_id;
							}

							if (e.height == null) {
								e.height = 0;
							}

							e.selected = false;

							return ee;
						})

						this.userList = _record_data;
					} else {
						this.$toast.add({ severity: 'error', summary: this.$t('common.feedback.error'), detail: res.msg, life: 2000 });
					}
				})
			} else {
				this.$http('/api/admin/bathrecord/userNoRecordList', {
					enterprise_id: enterprise_id,
					enterprise_partition_id: enter_id,
					region_id: region_id,
					time: start_time.getTime(),
					times: end_time.getTime() + 86399999,
					page: this.pageIndex,
					page_size: this.pageSize,
				}).then(res => {
					if (res.code == 200) {
						//this.eventRecordList = res.data.data;
						this.totalCount = res.data.total;
						this.pageSize = res.data.per_page;

						var _record_data = res.data.data.map(e => {
							let ee = new Object();
							ee = e;

							if (e.id === null || e.id === -1) {
								ee.id = -1;
								ee.name = this.$t('showerRecords.states.anonymousUser');
								ee.employee_short_id_show = '-1';
							} else {
								ee.employee_short_id_show = e.employee_short_id;
							}

							if (e.height == null) {
								e.height = 0;
							}

							return ee;
						})

						this.userList = _record_data;
					} else {
						this.$toast.add({ severity: 'error', summary: this.$t('common.feedback.error'), detail: res.msg, life: 2000 });
					}
				})
			}
		},

		getBathRecordDetail(from_out) {
			let user_id, employee_short_id, employee_id;

			if (!from_out) {
				user_id = this.currUser.id;
				employee_short_id = this.currUser.employee_short_id;
				employee_id = this.currUser.employee_id;
			} else {
				user_id = this.alarmOptions.id;
				employee_short_id = this.alarmOptions.employee_short_id;
				employee_id = this.alarmOptions.bath_employee_id;
			}

			let {
				enterprise_id,
				enter_id,
				region_id,
				start_time,
				end_time
			} = this.formParams();

			this.$http('/api/admin/bathrecord/index', {
				enterprise_id: enterprise_id,
				enterprise_partition_id: enter_id,
				region_id: region_id,
				user_id: user_id,
				employee_short_id: employee_short_id,
				bath_employee_id: employee_id,
				page: this.recordPageIndex,
				page_size: this.recordPageSize,
				time: start_time.getTime(),
				times: end_time.getTime() + 86399999,
			}).then(res => {
				if (res.code == 200) {
					this.recordTotalCount = res.data.total;

					var _record_data = res.data.data.map(e => {
						let ee = new Object();
						ee = e;
						return ee;
					})

					this.bathRecordDetailList = _record_data;
				} else {
					this.$toast.add({ severity: 'error', summary: this.$t('common.feedback.error'), detail: res.msg, life: 2000 });
				}
			})
		},

		getDetails(row, index, inner) {
			this.eventDetail = {};

			this.$http('/api/admin/event/desc', {
				id: row.id
			}).then(res => {
				if (res.code == 200) {
					res.data.shr = res.data.users_info.length == 0 ? '' : res.data.users_info[0].user_name
					this.eventDetail = res.data;
					this.eventDetail.currentType = this.eventDetail.name;
				} else {
					this.$toast.add({ severity: 'error', summary: this.$t('showerRecords.messages.requestError'), detail: 'Name: ' + event.data.name, life: 3000 });
				}
			})

			this.complianceSelBtnIndex = -1;
			this.showDetailCompliance = false;
			this.complianceText = '';
			this.complianceTemp = 0;
			this.displayDetail = true;
			this.showRule = false;
			this.eventSelectedIndex = index;

			if (!inner) {
				for (let i = 0; i < this.eventRecordList.length; i++) {
					this.eventRecordList[i].selected = false;
				}
				this.eventRecordList[index].selected = true;
			}
		},

		getEnterpriseList() {
			this.$http("/api/admin/enterprise/index", {}).then((res) => {
				if (res.code == 200) {
					this.enterpriseList = res.data;
				}
			});
		},
		onEnterpriseChange(type) {
			if (type == "search") {
				this.getFieldList(this.searchParams.enterpriseId);
			} else {
				this.getFieldList(this.deviceInfo.enterpriseId);
			}
		},

		// 获取场地列表
		getFieldList(enterprise_id) {
			this.$http("/api/admin/partition/index", { enterprise_id }).then(
				(res) => {
					if (res.code == 200) {
						this.fieldList = res.data.data;
					}
				}
			);
		},

		onFieldChange(type) {
			if (type == "search") {
				this.getRegionList(this.searchParams.enterprisePartitionId);
			} else {
				this.getRegionList(this.deviceInfo.enterprisePartitionId);
			}
		},

		// 获取区域列表
		getRegionList(enterprise_partition_id) {
			this.$http("/api/admin/region/cdindex", {
				enterprise_partition_id: enterprise_partition_id
			}).then((res) => {
				if (res.code == 200) {
					this.regionList = res.data;
				}
			});
		},

		onRegionChange() {
			// this.getPositionList(this.deviceInfo.region);
		},

		onSearch() {
			this.getUserList();
		},

		onFileDownload(event) {
			this.$confirm.require({
				target: event.currentTarget,
				message: this.$t('showerRecords.download.confirmExcel'),
				icon: 'pi pi-exclamation-triangle',
				acceptClass: 'p-button-text',
				rejectClass: 'p-button-primary',
				accept: () => {
					let url_str;

					url_str = this.$hostUrl + "/api/admin/bathrecord/exportExcel";

					//判断总条数是否大于1000条，如果大于，则弹框提示错误
					if (this.totalCount > 1000) {
						this.$toast.add({ severity: 'error', summary: this.$t('showerRecords.messages.dataError'), detail: this.$t('showerRecords.download.tooManyRecords'), life: 3000 });
						return
					}

					let {
						enterprise_id,
						enter_id,
						region_id,
						start_time,
						end_time
					} = this.formParams();

					let data = {
						enterprise_id: enterprise_id,
						enterprise_partition_id: enter_id,
						region_id: region_id,
						time: start_time.getTime(),
						times: end_time.getTime() + 86399999,
					}

					this.displayDownload = true;

					axios.post(url_str, data, {
						headers: {
							admintoken: this.localUserInfo.token,
						},
						responseType: 'arraybuffer',
					}).then((res) => {
						if (res.status == 200) {
							let file_ext = 'xlsx'
							if (res.headers['content-type'].indexOf('word', 0) != -1) {
								file_ext = 'docx'
							}

							let blob = new Blob([res.data]);
							let url = window.URL.createObjectURL(blob); // 创建 url 并指向 blob
							let a = document.createElement('a');
							a.href = url;
							a.download = this.$t('showerRecords.download.reportName') + '.' + file_ext;
							a.click();
							window.URL.revokeObjectURL(url); // 释放该 url
						} else {
							this.$toast.add({ severity: 'error', summary: this.$t('showerRecords.messages.requestError'), detail: res.msg, life: 3000 });
						}

						this.displayDownload = false;
					}).catch((err) => {
					this.$toast.add({ severity: 'error', summary: this.$t('showerRecords.messages.requestError'), detail: this.$t('showerRecords.messages.networkError') + err, life: 3000 });
						this.displayDownload = false;
					});
				},
				reject: () => {
				}
			});
		},

		onPage(event) {
			this.pageIndex = event.page + 1;
			this.getUserList();
		},

		onRecordPage(event) {
			this.recordPageIndex = event.page + 1;
			this.recordPageSize = event.rows;
			this.getBathRecordDetail(false);
		},
		formatCurrency(value) {
			if(value)
				return value.toLocaleString('en-US', {style: 'currency', currency: 'USD'});
			return;
		},

	}
}
</script>

<style scoped lang="scss">
@import '../assets/demo/badges.scss';

.goOnCheckActive {
	font-size: 20px;
	font-weight: bold;
	background-color: aqua;
}

.goOnCheckDeactive {
	font-size: 20px;
	font-weight: bold;
	background-color: #000000;
}


.custom .p-scrollpanel-wrapper {
	border-right: 9px solid #f4f4f4;
}

.custom .p-scrollpanel-bar {
	background-color: #1976d2;
	opacity: 1;
	transition: background-color .3s;
}

.custom .p-scrollpanel-bar:hover {
	background-color: #135ba1;
}

:deep(.row-accessories) {
	background-color: rgba(0, 0, 0, 0.15) !important;
}
</style>
